



















































import Vue from 'vue'
import { mapGetters } from 'vuex'
import subscriptionMixin from '@/mixins/subscription-mixin.js'
export default Vue.extend({
    mixins: [subscriptionMixin],
    props: {
        //  The unique id of the component (used for multiple dialogs)
        id: {
            type: Number,
            default: null
        }
    },
    mounted() {
        //  Initialize our calendly script
        this.initCalendly()
    },
    computed: {
        ...mapGetters(['authIsAdmin', 'subscription']),
        content() {
            return {
                broadcast_limit: {
                    title:
                        this.tier === 'Team'
                            ? "You're exceeding the limits of your MessageDesk Subscription"
                            : 'This Broadcast exceeds your contact limit per broadcast.',
                    description:
                        this.tier === 'Team'
                            ? 'Please contact sales to discuss how you can extend your Broadcast limits. Otherwise, we suggest:'
                            : 'To proceed, we suggest:',
                    bullets: [
                        'Reduce your group size to under your contact limit. Feel free to create multiple groups to still reach all your contacts',
                        'Upgrade your subscription to increase your limit.',
                        'Register your number in order to ensure delivery for high-volume messages. This will help you avoid getting marked as unwanted SPAM by the carriers'
                    ],
                    salesButtonId: this.tier === 'Team' ? 'BroadcastLimit' : null
                },
                user_limit: {
                    title: "Oops... you've reached your user limit on your current plan",
                    description:
                        "You can purchase more users by clicking 'Manage Plan' below",
                    bullets: []
                },
                branding_enabled: {
                    title: 'Oops... upgrade to the Team Plan to remove our MessageDesk branding',
                    description: 'Get access to:',
                    bullets: [
                        '3,500 monthly messages',
                        '10 teammates',
                        'Office Hours',
                        'Broadcast Message up to 2,000 contacts at once'
                    ]
                },
                inbox_setting_enabled: {
                    title: 'Oops... upgrade to the Operator Plan to access Inbox Settings',
                    description: 'Get access to:',
                    bullets: [
                        '1,000 monthly messages',
                        '3 teammates',
                        'Message Scheduling & Signatures',
                        'Autoresponders, Click-to-Text and Chatbot',
                        'Broadcast Message to up to 1,000 contacts at once'
                    ]
                },
                scheduling_enabled: {
                    title: 'Oops... upgrade to the Operator Plan to schedule messages',
                    description: 'Get access to:',
                    bullets: [
                        '1,000 monthly messages',
                        '3 teammates',
                        'Message Scheduling & Signatures',
                        'Autoresponders, Click-to-Text and Chatbot',
                        'Broadcast Message to up to 1,000 contacts at once'
                    ]
                },
                signature_enabled: {
                    title: 'Oops... upgrade to the Operator Plan to use message signatures',
                    description: 'Get access to:',
                    bullets: [
                        '1,000 monthly messages',
                        '3 teammates',
                        'Message Scheduling & Signatures',
                        'Autoresponders, Click-to-Text and Chatbot',
                        'Broadcast Message to up to 1,000 contacts at once'
                    ]
                }
            }
        },
        currentPlan() {
            return this.$store.getters.plan
        },
        dialog() {
            return this.$store.getters.dialogFeature[this.id]
        },
        monthly() {
            if (!this.currentPlan) return null

            return this.currentPlan.interval == 'month'
        },
        nextPlan() {
            if (this.monthly) return this.monthPlan

            return this.yearPlan
        },
        monthPlan() {
            //  Filter our plans
            const monthOptions = this.$store.getters.monthOptions

            //  If no plans, do nothing
            if (!monthOptions) return null

            const availableMonthly = monthOptions
                .filter(
                    (x) =>
                        x.metadata.is_active === 'true' &&
                        x.metadata.default_start_plan !== 'true'
                )
                .sort((a, b) => {
                    return a.metadata.index - b.metadata.index
                })

            const nextPlanMonthly = availableMonthly.find((plan) =>
                this.dialog.paywall_type == 'access'
                    ? plan.metadata[this.dialog.metadata] !== 'false'
                    : parseInt(plan.metadata[this.dialog.metadata]) >
                      parseInt(this.currentPlan.metadata[this.dialog.metadata])
            )

            return nextPlanMonthly
        },
        tier(): string {
            return this.$store.getters.productTier
        },
        yearPlan() {
            //  Filter our plans
            const yearOptions = this.$store.getters.yearOptions

            //  If no plans, do nothing
            if (!yearOptions) return null

            const availableAnnual = yearOptions
                .filter(
                    (x) =>
                        x.metadata.is_active === 'true' &&
                        x.metadata.default_start_plan !== 'true'
                )
                .sort((a, b) => {
                    return a.metadata.index - b.metadata.index
                })

            const nextPlanYearly = availableAnnual.find((plan) =>
                this.dialog.paywall_type == 'access'
                    ? plan.metadata[this.dialog.metadata] !== 'false'
                    : parseInt(plan.metadata[this.dialog.metadata]) >
                      parseInt(this.currentPlan.metadata[this.dialog.metadata])
            )

            return nextPlanYearly
        }
    },
    methods: {
        initCalendly(): void {
            //  Embed script for calendly
            let embedCalendly = document.createElement('script')
            embedCalendly.setAttribute(
                'src',
                'https://assets.calendly.com/assets/external/widget.js'
            )
            embedCalendly.setAttribute('async', 'async')
            document.head.appendChild(embedCalendly)

            //  Embed calendly css stylesheet
            let calendlyCSS = document.createElement('link')
            calendlyCSS.setAttribute(
                'href',
                'https://assets.calendly.com/assets/external/widget.css'
            )
            calendlyCSS.setAttribute('rel', 'stylesheet')
            document.head.appendChild(calendlyCSS)
        },
        managePlanClicked(): void {
            //  Check if this is a user addon
            const userAddon = this.dialog.addon_type === 'user'

            //  If this is a limit AND we have a user addon type, then let them add it
            if (userAddon)
                this.$router.push(`/billing/manage?addon=${this.dialog.addon_type}`)
            //  Else, regardless we just take them to change plan
            else
                this.$router.push(`/billing/manage?index=${this.nextPlan.metadata.index}`)

            //  Close any open app dialog under this dialog
            this.$store.dispatch('dialogClose', 'APP')

            return this.close()
        },
        talkToSalesClicked(): void {
            //  Super specific because MCS wants it this way
            const proceed =
                this.tier !== 'Team' || this.dialog.metadata !== 'broadcast_limit'

            //  If proceed is false, return
            if (!proceed) return this.close()

            // @ts-ignore
            Calendly.initPopupWidget({
                url: 'https://calendly.com/d/cqdk-krr-g3n/messagedesk-account-meeting'
            })
        },
        close(): void {
            return this.$store.dispatch('dialogClose', 'FEATURE')
        }
    }
})
